<template>
  <div>
    <vxe-grid
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      size="small"
      resizable
      border
      :seq-config="{
        startIndex: (tablePage.curPage - 1) * tablePage.pageSize,
      }"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:createInfo="{ row }">
        <span>{{ row.createByName }}</span>
        <br />
        <span>{{ row.createTime }}</span>
      </template>
      <template v-slot:taskStatus="{ row }">
        <el-tag
          size="mini"
          :type="
            row.taskStatus == 'Y'
              ? 'success'
              : row.taskStatus == 'E'
              ? 'danger'
              : ''
          "
        >
          {{ row.v_taskStatus }}
        </el-tag>
      </template>
      <template v-slot:timeliness="{ row }">
        <el-tag type="info">{{ row.v_timeliness }}</el-tag>
      </template>
      <template v-slot:opt="{ row }">
        <div style="text-align: center">
          <el-dropdown trigger="click" @command="optCommand">
            <span class="el-dropdown-link">
              {{ $l('INDEX.choose_fabric_function') || '功能' }}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                icon="el-icon-refresh-left"
                :command="{ menuType: 'reship', data: row }"
                :disabled="row.taskStatus != 'E' || !allow('R')"
              >
                {{ $l('menu_text_reship') || '重新发送' }}
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.table_label_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
    <el-dialog
      v-loading="loading"
      :visible.sync="visible"
      :title="$l('dialog_title_choose_channel') || '选择发送渠道'"
      show-close
      top="5vh"
      width="600px"
      :close-on-click-modal="false"
      :before-close="() => close()"
      v-el-dialog-drag
      destroy-on-close
    >
      <el-form ref="form" :model="form" size="small" label-width="140px">
        <el-row :gutter="20">
          <el-col :span="20">
            <el-form-item :label="$l('table_label_channelId') || '发送渠道'">
              <dict-select
                clearable
                v-model="form.channelId"
                :body="{ dictType: 'ChannelId' }"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                filterable
                size="small"
                url="/sys/common/dict/system"
              ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer">
        <el-button size="small" @click="close()">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-badge class="ml-2">
          <el-button type="primary" size="small" @click="reship()">
            {{ $l('INDEX.btn_confirm') || '确认' }}
          </el-button>
        </el-badge>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
export default {
  mixins: [TableAutoHeight],
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
    tablePage: {
      default: null,
      type: Object,
    },
    loading: {
      default: false,
    },
  },
  data() {
    return {
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
        refresh: {
          query: () => this.$emit('reload'),
        },
        zoom: true,
        custom: true,
      },
      visible: false,
      form: {
        channelId: '0',
        messageTaskCode: '',
      },

      tableColumns: tableColumns(this),
    }
  },
  methods: {
    optCommand({ menuType, data }) {
      const { messageTaskCode } = data
      switch (menuType) {
        case 'reship':
          this.visible = true
          this.form.channelId = '0'
          this.form.messageTaskCode = messageTaskCode
          break
      }
    },
    reship() {
      this.$api.sysMessageTaskReshipApi(this.form).then((res) => {
        const { status } = res || {}
        if (status !== 200) {
          this.$message.error(this.$l('tips_reship_error') || '重发失败！')
          return
        }
        this.$message.success(this.$l('tips_reship_success') || '重发成功！')
        this.close()
      })
    },
    close() {
      this.form = {
        channelId: '0',
        messageTaskCode: '',
      }
      this.visible = false
    },
  },
}
</script>
